import React, { Component } from "react";
import Helmet from "react-helmet";
import Header from "../components/Header/Header";
import SocialLinks from "../components/SocialLinks/SocialLinks";
import SEO from "../components/SEO/SEO";
import Portail from "../components/Page/Portail";
import HeaderPage from "../components/Header/HeaderPage";
import Menu from "../components/Menu/Menu";
import Footer from "../components/Footer/Footer";
import picture from "./img/puzzle.jpg";
import config from "../../data/SiteConfig";
import Contact from "../components/Contact/Contact";
import "./page.scss";

export default class PortailWebApp extends Component {
  render() {
    // SEO PURPOSES
    const { slug } = this.props.pathContext;


    const postNode = {
        "frontmatter": {
            "title": "Création de portail Web Collaboratif",
            "description":  "Integral Service développe des portails Web de type Intranet et/ou Extranet collaboratif pour répondre aux besoins de votre métier.",
            "cover": picture
        }
    };

    let title = "Portail Web";
    let description = "Des portails collaboratifs adaptés à vos besoins";
    let goto = "En découvrir plus";

    return (
      <div className="webapp-container page-details">
          <Header/>
          <Menu />
          <Helmet 
          title={`Portail Web Collaboratif | ${config.siteTitle}`}
          description = {`Integral Service développe des portails Web de type Intranet et/ou Extranet collaboratif pour répondre aux besoins de votre métier.`}
          />
          <SEO postPath={slug} postNode={postNode} postSEO />
          <HeaderPage title={title} description={description} picture={picture} />
          <Portail />
          <Contact />
          <SocialLinks postPath={slug} postNode={postNode} />
          <Footer />
      </div>
    );
  }
}
;


// WEBPACK FOOTER //
// ./src/pages/portail-web-collaboratif.jsx